import { Stepper } from 'antd-mobile'
import styles from './index.scss'
import classnames from 'classnames'

type PropsType = {
  value?: any
  onChange?: any
  stepperProps?: Record<string, any>
  title?: string
  description?: string
  style?: React.CSSProperties
  bodyStyle?: React.CSSProperties
  hiddenTitle?: boolean
  extraRender?: React.ReactNode | string | undefined
  min?: number
  disabled?: boolean
  className?: string
  stepperClassName?: string
}

const CommonStepper = (props: PropsType) => {
  return (
    <>
      <div
        className={classnames(
          {
            [styles['dp-commonStepper']]: true,
            'dp-commonStepper': true,
            [styles['dp-commonStepper-disabled']]:
              props?.disabled || !!props?.stepperProps?.inputReadOnly,
          },
          props?.className,
        )}
        style={props?.bodyStyle}
      >
        <div>
          {!props?.hiddenTitle && (
            <div className={styles.text} style={props?.style}>
              {props?.title || '数量'}
            </div>
          )}
          {!props?.hiddenTitle && props?.description && (
            <div className={styles.description} style={props?.style}>
              {props?.description}
            </div>
          )}
        </div>
        <div className={styles['dp-stepper']}>
          <Stepper
            className={props?.stepperClassName}
            style={{
              '--button-font-size': '16px',
              '--button-text-color': 'var(--text-color, #202020)',
              '--input-width': '44px',
              ...props?.stepperProps?.style,
            }}
            value={props?.value}
            min={props?.min ?? 1}
            {...props?.stepperProps}
            onChange={(value) => props?.onChange?.(value)}
            aria-label={'数量选择器'}
          />
        </div>
      </div>
      {props?.extraRender}
    </>
  )
}

CommonStepper.Stepper = Stepper
export default CommonStepper
